class AssemblyProductsList extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('AssemblyCategoryDropdown:change', (e) =>
      this.onCategoryChange(e.target.value),
    );
  }

  hideProducts() {
    this.querySelectorAll('[data-category]').forEach(
      (node) => (node.style.display = 'none'),
    );
  }

  showProducts(category) {
    this.querySelectorAll(`[data-category="${category}"]`).forEach(
      (node) => (node.style.display = 'flex'),
    );
  }

  selectFirstProduct(category, productId = null) {
    let product;

    if (productId) {
      product = this.querySelector(
        `[data-product-id="${productId}"][data-category="${category}"]`,
      );
    }

    if (!product) {
      product = this.querySelectorAll(`[data-category="${category}"]`)?.[0];
    }

    if (product) {
      product.hideInstructions();
      product.showInstructions(product.dataset.productId);
      return product.dataset.productId;
    }
    return null;
  }

  onCategoryChange(category, updateUrl = true) {
    this.hideProducts();
    this.showProducts(category);
    const productId = this.selectFirstProduct(category);

    if (updateUrl) {
      // Only update URL with category, not product ID
      // Product ID will be added when user clicks on a product
      updateAssemblyUrl(category, null);
    }
  }
}

class AssemblyProduct extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(e) {
    // Get the product element (in case click is on a child element)
    const productElement = e.target.closest('assembly-product') || this;
    const productId = productElement.dataset.productId;
    const category = productElement.dataset.category;

    if (!productId || !category) {
      return;
    }

    this.hideInstructions();
    this.showInstructions(productId);

    // Update URL with category and product ID
    updateAssemblyUrl(category, productId);

    document.getElementById('assembly-instructions').scrollIntoView();
  }

  hideInstructions() {
    document
      .querySelectorAll('.assembly-instructions')
      .forEach((node) => node.classList.add('assembly-instructions--hidden'));
  }

  showInstructions(productId) {
    document
      .querySelectorAll(
        `.assembly-instructions[data-product-id="${productId}"]`,
      )
      .forEach((node) =>
        node.classList.remove('assembly-instructions--hidden'),
      );
  }
}

// Helper function to update URL with category and product parameters
function updateAssemblyUrl(category, productId = null) {
  const url = new URL(window.location);

  if (category) {
    url.searchParams.set('category', encodeURIComponent(category));
  } else {
    url.searchParams.delete('category');
  }

  if (productId) {
    url.searchParams.set('product', encodeURIComponent(productId));
  } else {
    url.searchParams.delete('product');
  }

  window.history.pushState({}, '', url);
}

// Helper function to get URL parameters
function getUrlParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    category: params.get('category')
      ? decodeURIComponent(params.get('category'))
      : null,
    product: params.get('product')
      ? decodeURIComponent(params.get('product'))
      : null,
  };
}

// Initialize page based on URL parameters
function initializeFromUrl() {
  const { category, product } = getUrlParams();
  const dropdown = document.querySelector(
    '.assembly-category-dropdown__select',
  );
  const productsList = document.querySelector('assembly-products-list');

  if (category && dropdown) {
    // Find the option that matches the category
    const options = Array.from(dropdown.options);
    const matchingOption = options.find(
      (opt) => opt.textContent.trim() === category,
    );

    if (matchingOption) {
      dropdown.value = category;

      // Trigger the category change
      if (productsList) {
        productsList.onCategoryChange(category, false);

        // If there's a product ID in the URL, select that product
        if (product && productsList) {
          const productElement = productsList.querySelector(
            `[data-product-id="${product}"][data-category="${category}"]`,
          );
          if (productElement) {
            productElement.hideInstructions();
            productElement.showInstructions(product);
          }
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.assembly-category-dropdown__select')
    .forEach((dropdown) => {
      dropdown.addEventListener('change', () => {
        dropdown.dispatchEvent(
          new Event('AssemblyCategoryDropdown:change', {
            bubbles: true,
          }),
        );
      });
    });

  if (!customElements.get('assembly-products-list'))
    customElements.define('assembly-products-list', AssemblyProductsList);

  if (!customElements.get('assembly-product'))
    customElements.define('assembly-product', AssemblyProduct);

  // Initialize from URL parameters after custom elements are defined
  setTimeout(() => {
    initializeFromUrl();
  }, 0);

  // Handle browser back/forward buttons
  window.addEventListener('popstate', () => {
    initializeFromUrl();
  });
});
